export default "__VITE_ASSET__BGeBWQLV__"